import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../../components/ui/table";
import { BarChart3, ArrowLeft, Users, Car, Loader2 } from "lucide-react";

export default function Utilizacao() {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const hoje = new Date().toISOString().slice(0, 10);
  const trintaAtras = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  const [de, setDe] = useState(trintaAtras);
  const [ate, setAte] = useState(hoje);

  const carregar = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/roteirizacao/utilizacao", { params: { data_de: de, data_ate: ate } });
      setDados(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { carregar(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="space-y-4" data-testid="utilizacao-page">
      <div className="flex items-center gap-3">
        <Link to="/app/roteirizacao"><Button variant="ghost" size="sm"><ArrowLeft size={14} /></Button></Link>
        <BarChart3 size={26} style={{ color: "#1B3A6B" }} />
        <h1 className="text-2xl font-bold" style={{ color: "#1B3A6B" }}>Utilização Operacional</h1>
      </div>

      <Card className="p-3 flex items-end gap-3 flex-wrap">
        <div>
          <Label className="text-xs">De</Label>
          <Input type="date" value={de} onChange={(e) => setDe(e.target.value)} className="w-40" data-testid="util-de" />
        </div>
        <div>
          <Label className="text-xs">Até</Label>
          <Input type="date" value={ate} onChange={(e) => setAte(e.target.value)} className="w-40" data-testid="util-ate" />
        </div>
        <Button onClick={carregar} disabled={loading} data-testid="btn-aplicar-util">
          {loading ? <Loader2 className="animate-spin mr-1" size={14} /> : null}
          Aplicar
        </Button>
      </Card>

      {/* KPIs */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Card className="p-3 border-l-4 border-l-blue-500" data-testid="util-kpi-rotas">
          <div className="text-xs text-muted-foreground">Rotas no período</div>
          <div className="text-2xl font-bold">{dados?.total_rotas ?? "—"}</div>
        </Card>
        <Card className="p-3 border-l-4 border-l-emerald-500" data-testid="util-kpi-concluidas">
          <div className="text-xs text-muted-foreground">Rotas concluídas</div>
          <div className="text-2xl font-bold text-emerald-700">{dados?.total_rotas_concluidas ?? "—"}</div>
        </Card>
        <Card className="p-3 border-l-4 border-l-violet-500" data-testid="util-kpi-paradas">
          <div className="text-xs text-muted-foreground">Clientes programados (paradas)</div>
          <div className="text-2xl font-bold text-violet-700">{dados?.total_clientes_atendidos_programados ?? "—"}</div>
        </Card>
        <Card className="p-3 border-l-4 border-l-amber-500" data-testid="util-kpi-atendimentos">
          <div className="text-xs text-muted-foreground">Atendimentos concluídos</div>
          <div className="text-2xl font-bold text-amber-700">{dados?.total_atendimentos_concluidos ?? "—"}</div>
        </Card>
      </div>

      {/* Ranking motoristas */}
      <Card>
        <div className="p-3 border-b flex items-center gap-2 font-bold" style={{ color: "#1B3A6B" }}>
          <Users size={16} /> Ranking de motoristas
        </div>
        <Table>
          <TableHeader>
            <TableRow><TableHead>Motorista</TableHead><TableHead className="text-center">Rotas</TableHead><TableHead className="text-center">Atendimentos concluídos</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {(dados?.ranking_motoristas || []).length === 0 && (
              <TableRow><TableCell colSpan={3} className="text-center py-4 text-muted-foreground">Sem dados no período.</TableCell></TableRow>
            )}
            {(dados?.ranking_motoristas || []).map((m) => (
              <TableRow key={m.motorista_id}>
                <TableCell>{m.nome || "—"}</TableCell>
                <TableCell className="text-center">{m.rotas}</TableCell>
                <TableCell className="text-center font-bold">{m.atendimentos}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>

      {/* Uso de veículos */}
      <Card>
        <div className="p-3 border-b flex items-center gap-2 font-bold" style={{ color: "#1B3A6B" }}>
          <Car size={16} /> Uso de veículos
        </div>
        <Table>
          <TableHeader>
            <TableRow><TableHead>Veículo</TableHead><TableHead className="text-center">Rotas</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {(dados?.uso_veiculos || []).length === 0 && (
              <TableRow><TableCell colSpan={2} className="text-center py-4 text-muted-foreground">Sem dados no período.</TableCell></TableRow>
            )}
            {(dados?.uso_veiculos || []).map((v) => (
              <TableRow key={v.veiculo_id}>
                <TableCell className="font-mono">{v.placa || "—"}</TableCell>
                <TableCell className="text-center font-bold">{v.rotas}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
